export const NATUR_AIR_URL = "https://www.natur-air.com";

export const NaturAirText = ({ text, testid = "text" }) => {
  const parts = text.split("Natur Air");
  return (
    <>
      {parts.map((part, i) => (
        <span key={i}>
          {part}
          {i < parts.length - 1 && (
            <a
              href={NATUR_AIR_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`natur-air-link-${testid}`}
              className="text-[#EED8A1] underline decoration-[rgba(197,160,89,0.5)] underline-offset-4 hover:text-[#C5A059] transition-colors"
            >
              Natur Air
            </a>
          )}
        </span>
      ))}
    </>
  );
};
